const tvList = {
    tableList: [
        {
            'id': 1,
            'text': 'No',
            'name':'#',
            'visible': true,
            'className': 'text-center'
        },{
            'id': 4,
            'text': 'Display Name',
            'name':'display_name',
            'visible': true,
            'className': null
        },{
            'id': 10,
            'text': 'Queues',
            'name':'queue_list',
            'visible': true,
            'className': null
        },   {
            'id': 5,
            'text': 'Status',
            'name':'status',
            'visible': true,
            'className': null
        }, {
            'id': 6,
            'text': 'Action',
            'name':'action',
            'visible': true,
            'className': null
        }
    ]
};

const tvForm = {
    feilds: [
        {
            id: 0,
            name: 'diaplay',
            text: 'Add New TV Display',
            visible: true,
            element: 'label',
            className: [],
            required: false
        }, {
            id: 1,
            name: 'displayName',
            text: 'Enter TV Display Name',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter TV Display Name',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Your TV Display Name'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: []
        }, {
            id: 2,
            name: 'password',
            text: 'Enter User Password',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'password',
            placeholder: 'Enter user Password',
            icon: 'lock',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Your User Name'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: []
        }, {
            id: 5,
            name: 'unit',
            text: 'Select Unit',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'text',
            placeholder: 'Select Unit',
            icon: 'lock',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Unit'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: []
        }, {
            id: 7,
            name: 'department',
            text: 'Select Department',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'text',
            placeholder: 'Select Department',
            icon: 'lock',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Department'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: []
        }, {
            id: 8,
            name: 'service',
            text: 'Select Service',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'text',
            placeholder: 'Select Service',
            icon: 'lock',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Service'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: []
        },{
            id: 9,
            name: 'queues',
            text: 'Select Queue',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'text',
            placeholder: 'Select Queue',
            icon: 'lock',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: []
        }, {
            id: 20,
            name: 'button',
            text: 'TV Screen',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        }
    ]
};

export {tvList, tvForm};
